import { Toaster as Sonner } from "sonner";

export { toast } from "sonner";

/** App-wide toasts (sonner), themed with tokens. Mounted once in App. */
export function Toaster() {
  return (
    <Sonner
      position="top-center"
      closeButton
      toastOptions={{
        unstyled: false,
        classNames: {
          toast: "font-body rounded-lg border border-border bg-surface text-fg shadow-elevated",
          title: "font-semibold",
          description: "text-fg-muted",
          success: "border-success",
          error: "border-danger",
        },
      }}
    />
  );
}
